<template>
  <div class="email-preview-container">
    <div class="email-preview-image-container">
      <div v-if="urlHeaderImage">
        <img :src="urlHeaderImage" class="responsive-image" />
        <div class="d-flex justify-end mt-1">
          <download-file-button :url="urlHeaderImage" />
        </div>
      </div>
      <v-row v-else class="image-empty-state" align="center" no-gutters>
        <v-col class="empty-state">
          <mf-icon size="60">image</mf-icon>
          <p class="primary-text">Imagem do cabeçalho</p>
        </v-col>
      </v-row>
    </div>
    <div class="email-body-container">
      <subject-preview :message="subject || 'Seu título vem aqui'" :offer-type="offerType" channel="email" />
      <body-preview :message="body || 'O corpo do seu texto vem aqui'" :offer-type="offerType" channel="email" />
    </div>
    <div>
      <div v-if="urlBodyImage">
        <img :src="urlBodyImage" class="responsive-image" />
        <div class="d-flex justify-end mt-1">
          <download-file-button :url="urlBodyImage" />
        </div>
      </div>
      <v-row v-else class="image-empty-state" align="center" no-gutters>
        <v-col class="empty-state">
          <mf-icon size="60">image</mf-icon>
          <p class="primary-text">Imagem do corpo do e-mail</p>
        </v-col>
      </v-row>
    </div>
    <div class="mx-auto">
      <mf-button block size="lg" color="cinza-l10" :label="buttonText || 'Botão'" @click="goToLink" />
    </div>
    <div class="email-preview-footer">
      <span>{{ footerText || 'O texto do seu rodapé vem aqui' }}</span>
      <p class="footer-text-link">Para se descadastrar da lista de e-mail, <a class="footer-text-link" href="#">clique aqui</a></p>
    </div>
  </div>
</template>

<script>
import DownloadFileButton from '@/components/DownloadFileButton.vue'
import SubjectPreview from '@/modules/maria/campanha-da-maria-v2/views/components/ChannelsConfiguration/ChannelSettingsForm/EmailForm/SubjectPreview.vue'
import BodyPreview from '@/modules/maria/campanha-da-maria-v2/views/components/ChannelsConfiguration/ChannelSettingsForm/EmailForm/BodyPreview.vue'

export default {
  name: 'EmailPreview',
  components: {
    DownloadFileButton,
    SubjectPreview,
    BodyPreview,
  },
  props: {
    urlHeaderImage: {
      type: String,
      default: '',
    },
    urlBodyImage: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
    subject: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    footerText: {
      type: String,
      default: '',
    },
    buttonLink: {
      type: String,
      default: '',
    },
    offerType: {
      type: String,
      default: 'offer_sales',
      validator: (value) =>
        [
          'offer_sales',
          'percentage_offer_sales',
          'cashback_absolute_offer_sales',
          'cashback_percentage_offer_sales',
          'takepay_offer_sales',
          'points_offer_sales',
          'combo_offer_sales',
        ].includes(value),
    },
  },
  methods: {
    goToLink() {
      if (!this.buttonLink) return

      const formattedUrl = this.buttonLink.startsWith('http://') || this.buttonLink.startsWith('https://') ? this.buttonLink : 'https://' + this.buttonLink

      window.open(formattedUrl, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.email-preview-container {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.image-empty-state {
  display: flex;
  height: 190px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  background: $cinza-l80;
}

.empty-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 8px;
  border: 1px dashed $cinza-d10;
}

.email-body-container {
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: flex-start;
  width: 448px;
  gap: 8px;
  color: $cinza-d10;
  font-size: 16px;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: 0.4px;
}

.email-preview-footer {
  display: flex;
  padding: 20px 48px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  background: $cinza-l90;
  color: $cinza-d10;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.footer-text-link {
  color: $cinza-l10;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

p {
  margin-bottom: 0px !important;
}
</style>
